const EnumRecordTypes = {
    ContactCustomIds: 105,
    ContactDisplayIds: 110,
    DonationReceipts: 115,
    FinancialBatch: 120,
    Flow: 125,
    Invoices: 130,
    SurveyMonkey: 210,
    GoogleAnalytics: 215,
    OneSignal: 220,
    MailChimp: 230,
    Zoom: 240,
    Asana: 245,
    AzureBlobStorage: 250,
    ApiKey: 300,
    DirectSQLLogin: 305,
    TenantFullAccess: 310,
    TenantPublicAccess: 315,
    TenantReportingAccess: 320,
    SaaS: 405,
    SaaSRemoteDb: 410,
    User: 500,
    Processes: 1300,
    Organization: 3005,
    Person: 3010,
    Place: 3015,
    Address: 3100,
    EmailAddress: 3205,
    FaxNumber: 3210,
    PhoneNumber: 3215,
    Website: 3220,
    Collection: 7100,
    Campaign: 7105,
    CollectionItem: 7205,
    Period: 7210,
    Workflow: 7220,
    Committee: 7225,
    Position: 7230,
    NodeEdge: 7300,
    CategoryNode: 7305,
    CategoryTerm: 7310,
    Element: 7315,
    Follower: 7320,
    NodeEdgeOption: 7325,
    Participant: 7330,
    PrimaryContact: 7335,
    RelationshipOf: 7340,
    RelationshipType: 7345,
    Renewal: 7350,
    StatusTerm: 7355,
    Page: 10505,
    Section: 10510,
    Block: 10515,
    Code: 15405,
    Donation: 15410,
    Liability: 15415,
    Pledge: 15420,
    Product: 15425,
    ProductVariant: 15430,
    Service: 15435,
    EmailAlias: 20205,
    IMAP: 20210,
    SMTP: 20215,
    POP3: 20220,
    Recipient: 20300,
    Email: 20400,
    Flows: 20500,
    PostEdge: 20600,
    Post: 20700,
    Note: 20705,
    Task: 20710,
    TaskList: 20715,
    QueueEmail: 20800,
    TermEdge: 20900,
    Hierarchy: 20905,
    Term: 21000,
    Categories: 21105,
    ContactMethodTypes: 21110,
    ContactTypes: 21115,
    Custom: 21120,
    Folders: 21125,
    NamePrefixes: 21130,
    PostTypes: 21135,
    Sources: 21140,
    Statuses: 21145,
    Tags: 21150,
    UnitOfMeasure: 21155,
    Variants: 21160,

    Settings: 200,
    APP: 316,
    Activity: 202,
    Vocabularies: 203,

    Remittances: 1305,
    CatalogItems: 15500,
    Accounts: 15300,
    PaymentMethods: 17300,
    Orders: 16800,
    LineItem: 16900,
    Form: 10100,
    Payments: 1100,

    OrderStatus: 16830,
    OrderPeriod: 16831,
    OrderTag: 16832,

    UserAudit: 555, // Used only in UI
    Password: 556, // Used only in UI
    Articles: 557, // articles
};

export default EnumRecordTypes;